import { useCallback } from 'react';

import { Button } from '@/lib/base/buttons/button';

interface ShowReasoningButtonProps {
  chainId: string;
  onOpenReasoningSidebar: (chainId: string) => void;
}

/** Opens the reasoning side panel for one chain. */
export function ShowReasoningButton({
  chainId,
  onOpenReasoningSidebar,
}: ShowReasoningButtonProps) {
  const handleClick = useCallback(
    () => onOpenReasoningSidebar(chainId),
    [onOpenReasoningSidebar, chainId]
  );

  return (
    <Button
      color='gray-soft'
      size='xs'
      onClick={handleClick}
      className='!rounded-full'
    >
      Show reasoning
    </Button>
  );
}
